import { useEffect, useState } from 'react';

export function useNowNextInterval(intervalMs: number | null | undefined): {
  showNextProgram: boolean;
} {
  const [showNextProgram, setShowNextProgram] = useState(false);

  useEffect(() => {
    const switchingIsDisabled = !intervalMs || intervalMs <= 0;
    if (switchingIsDisabled) {
      setShowNextProgram(false);
      return;
    }

    setShowNextProgram(false);
    const id = setInterval(() => {
      setShowNextProgram(prev => !prev);
    }, intervalMs);

    return () => {
      clearInterval(id);
    };
  }, [intervalMs]);

  return { showNextProgram };
}
